import {makeStyles} from '@material-ui/core/styles';
export default makeStyles((theme)=>({
    modal2:{
        height:'100%',
        width: '100%',
        position: 'fixed',
        backgroundColor: 'gray',
        top: 0,
        left: 0,
        opacity: .9,
        zIndex: 10,
    },
    
    modalcontent:{
        backgroundColor: 'white',
        margin: '200px auto',
        height: '50%',
        width: '30%',
        textalign:'center'
    },
    Wrapper:{
        position:'relative',
        zIndex: 0,
    },
   
 
}))

